export default __webpack_public_path__ + "static/media/TermsOfUse-FR.f6687e8a.pdf";